import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              韩漫网
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              韩漫网致力于为漫画爱好者提供海量正版韩国漫画免费在线阅读服务，资源齐全画质精良，支持多设备无缝切换，是您享受阅读乐趣的首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  全部分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">热门分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系方式</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hanman.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line"></i>
                <span>在线客服：周一至周五 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>韩国首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 韩漫网 HanMan. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}